// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__BkCdD","loaderOuter":"PageOverlayLoader_loaderOuter__2OGab"};